import { render, staticRenderFns } from "./OfficeScreen.vue?vue&type=template&id=64f6c5aa&scoped=true&"
import script from "./OfficeScreen.vue?vue&type=script&lang=js&"
export * from "./OfficeScreen.vue?vue&type=script&lang=js&"
import style0 from "./OfficeScreen.vue?vue&type=style&index=0&id=64f6c5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6c5aa",
  null
  
)

export default component.exports